import { LoadingButton } from "@mui/lab";
import { Box, Grid, Typography } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { AddOnItemName } from "schemas/dashboard";

import { PlanAction } from "features/Home/UpgradeDialog/Plan/helpers";
import { useSubscription } from "utils/useSubscription";

import CardWrapper from "../components/CardWrapper";
import styles from "./styles";

const BENEFITS = [
  {
    icon: "💯",
    primary: "Increase response rate",
    secondary:
      "We will highlight your background and unique selling points to make you stand out",
  },
  {
    icon: "⏰",
    primary: "Fast turn-around time",
    secondary: "Receive your template within 5 business days",
  },
];

const AddOnTemplate = () => {
  const { addOns } = useContext(SubscriptionContext);
  const { onPlanButtonClick, checkoutLoading } = useSubscription();

  return (
    <CardWrapper>
      <Grid item>
        <Typography variant="h5" component="div" gutterBottom>
          Custom Pitch Template
        </Typography>

        <Typography variant="h6" sx={{ color: "green.main" }} gutterBottom>
          ${addOns?.[AddOnItemName.pitching_templates]?.price.toFixed(2)}
          /template
          <Box component="span" sx={styles.annotationPrice}>
            One-time fee
          </Box>
        </Typography>

        <Typography gutterBottom>
          Make every word count! A professional copywriter will polish your
          pitch so brands can't wait to work with you.
        </Typography>

        {BENEFITS.map((benefit, index) => (
          <Grid container key={index} alignItems="center" sx={{ mb: 3 }}>
            <Grid
              container
              justifyContent="left"
              alignItems="center"
              item
              xs="auto"
            >
              <Box sx={styles.iconBlock}>{benefit.icon}</Box>
            </Grid>
            <Grid item xs md>
              <Typography>
                <strong>{benefit.primary}</strong>
              </Typography>
              <Typography>{benefit.secondary}</Typography>
            </Grid>
          </Grid>
        ))}
      </Grid>

      <Grid item>
        <LoadingButton
          variant="contained"
          disableElevation
          loading={checkoutLoading === AddOnItemName.pitching_templates}
          onClick={() =>
            onPlanButtonClick(
              AddOnItemName.pitching_templates,
              PlanAction.upgrade,
            )
          }
        >
          Purchase
        </LoadingButton>
      </Grid>
    </CardWrapper>
  );
};

export default AddOnTemplate;
